export interface ToolbarDeps {
  readonly onRestart: () => void;
  readonly onHint: () => void;
}

export interface ToolbarApi {
  setHintAvailable(available: boolean): void;
  sync(blocked: boolean): void;
  destroy(): void;
}

export function createToolbar(deps: ToolbarDeps): ToolbarApi {
  const restartButton = document.querySelector<HTMLButtonElement>('#restart-button');
  const hintButton = document.querySelector<HTMLButtonElement>('#hint-button');
  let hintAvailable = false;

  restartButton?.addEventListener('click', deps.onRestart);
  hintButton?.addEventListener('click', deps.onHint);

  return {
    setHintAvailable: (available) => {
      hintAvailable = available;
    },
    sync: (blocked) => {
      if (restartButton !== null) {
        restartButton.disabled = blocked;
      }
      if (hintButton !== null) {
        hintButton.disabled = blocked || !hintAvailable;
      }
    },
    destroy: () => {
      restartButton?.removeEventListener('click', deps.onRestart);
      hintButton?.removeEventListener('click', deps.onHint);
    },
  };
}
